import device from "src/styles/device";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  position: relative;
  margin: auto;

  & > div > p {
    word-wrap: break-word;
  }

  h4 {
    font-weight: 600;
    font-size: 1rem;
    margin: 1em 0;
    display: table;

    span {
      display: table-cell;
      font-weight: 500;
      font-size: 1rem;
      padding-right: 0.6em;
    }
  }

  p {
    font-weight: 400;

    &.text-indent {
      text-indent: 24px;
    }
  }
  p.credit-remark {
    font-weight: 500;
    font-size: 1rem;
    text-align: right;
    margin: 0.5em 0;
  }
  div.number-sublist {
    padding-left: 24px;

    @media ${device.mobileL} {
      padding-left: 16px;
    }
  }
  div.number-sublist > p,
  div.number-sublist > div.multiline {
    display: table;
    font-weight: 400;
    font-size: 1rem;

    &.text-indent {
      text-indent: 24px;
    }

    span {
      font-weight: 400;
      font-size: 1rem;
      display: table-cell;
      padding-right: 0.4em;
    }
  }

  div.number-sublist > ul {
    padding-left: 24px;

    @media ${device.mobileL} {
      padding-left: 16px;
    }
  }
  div.number-sublist > ul > li {
    list-style: none;
    display: table;
  }
  div.number-sublist > ul > li::before {
    content: "-";
    display: table-cell;
    padding-right: 0.6em;
  }

  ul {
    list-style-type: none;
    margin-bottom: 1em;
  }
  ul > li {
    font-weight: 400;
    font-size: 1rem;
    margin-bottom: 0.5em;
  }
  ul.indent-choice > li {
    list-style-type: disc;
  }
  ul.subindent-choice > li {
    list-style-type: circle;
  }
  ul.decimal-choice > li {
    list-style-type: decimal;
  }
`;

const Table = styled.table`
  width: 100%;
  max-width: 1440px;
  margin: 40px 0 20px;
  border: 1px solid black;
  border-spacing: 0px;

  & > thead,
  & > tbody,
  & > tbody > tr {
    border: 1px solid black;
  }

  & > thead > tr > th {
    border: 1px solid black;
    font-weight: 500;
    padding: 8px;
    text-align: center;
  }

  & > tbody > tr > td {
    border: 1px solid black;
    padding: 8px;
  }
`;

const TermContentEn = ({ contractPercent, hideHeader = false }) => {
  return (
    <Container>
      <div>
        {!hideHeader && (
          <h3
            style={{ "-webkit-text-align": "center", "text-align": "center" }}
          >
            <strong>XSURFACE Seller Terms and Conditions Agreement</strong>
          </h3>
        )}

        <p>
          This document outlines the terms, service conditions, and fee
          structures for sellers partnering with
          <span class="Apple-converted-space">&nbsp; </span> XSURFACE Co., Ltd.
          Sellers agree to the following terms upon onboarding
          <span class="Apple-converted-space">&nbsp; </span> and using the
          XSURFACE platform and services.
        </p>

        <h4>
          <span>1.</span> Types of Seller Partnerships
        </h4>

        <p>XSURFACE authorizes two types of sales models for sellers:</p>

        <div className="number-sublist">
          <p>
            <span>1.</span>
            Consignment Sales: XSURFACE purchases and resells products directly
            to customers.
          </p>
          <p>
            <span>2.</span>
            Commission-Based Sales: XSURFACE facilitates sales between the
            seller and end customer and charges a commission fee.
          </p>
        </div>

        <p>Sellers agree to the following baseline service fees:</p>

        <Table>
          <thead>
            <tr>
              <th>No.</th>
              <th>Sales Model</th>
              <th>Details</th>
              <th>Base Fee*</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                <p>1</p>
              </td>
              <td>
                <p>XSURFACE Resale</p>
              </td>
              <td>
                <p>XSURFACE markets and sets selling price.</p>
              </td>
              <td>
                <p>-</p>
              </td>
            </tr>

            <tr>
              <td>
                <p>2</p>
              </td>
              <td>
                <p>Commission Fee</p>
              </td>
              <td>
                <p>When a sale occurs through XSURFACE platform.</p>
              </td>
              <td>
                <p>Minimum fee as follows:</p>
              </td>
            </tr>

            <tr>
              <td>
                <p>2.1</p>
              </td>
              <td>
                <p>Cash/Bank Transfer Sales</p>
              </td>
              <td>
                <p>
                  {contractPercent.fee} of net value + 7% VAT on commission.
                </p>
              </td>
              <td>
                <p style={{ whiteSpace: "pre-line" }}>
                  {contractPercent.fee}
                  (+ VAT 7%)
                </p>
              </td>
            </tr>

            <tr>
              <td>
                <p>2.2</p>
              </td>
              <td>
                <p>Credit Card Sales</p>
              </td>
              <td>
                <p>
                  {contractPercent.desc} + {contractPercent.feeCard} credit card
                  fee + 7% VAT on commission.
                </p>
              </td>
              <td>
                <p style={{ whiteSpace: "pre-line" }}>
                  {contractPercent.fee} + {contractPercent.feeCard} (+ VAT 7%)
                </p>
              </td>
            </tr>
          </tbody>
        </Table>

        <p>
          *Fees are subject to change depending on product category and future
          updates.
        </p>

        <p>&nbsp;</p>

        <h4>
          <span>2.</span> Details of Sales Models&nbsp;
        </h4>

        <p>2.1 Consignment Sales&nbsp;</p>

        <ul className="indent-choice">
          <li>XSURFACE buys goods from seller and sells to customers.</li>
          <li>
            Seller must deliver products as per XSURFACE's order notifications.
          </li>
          <li>
            Invoices and tax receipts must be scanned and sent immediately, and
            original documents provided within the same month.
          </li>
          <li>
            Sellers must update inventory and pricing daily before 10:00 AM.
          </li>
          <li>Billing: For orders made from the 1st - 30th of each month:</li>
          <ul className="subindent-choice">
            <li>
              Invoice must be submitted by the 1st - 5th of the following month.
            </li>
            <li>
              Payment will be made by the 5th of the following month (based on
              XSURFACE receiving payment from customers).
            </li>
          </ul>
        </ul>

        <p>2.2 Commission-Based Sales&nbsp;</p>

        <ul className="indent-choice">
          <li>XSURFACE sells directly and deducts a commission.</li>
          <li>
            Seller is paid the remaining balance by the 5th of the following
            month.
          </li>
          <li>
            XSURFACE issues commission receipts on the 30th of every month.
          </li>
          <li>
            For installation/labor costs, the seller must submit a 3%
            withholding tax form within 7 days of receiving payment.
          </li>
          <li>
            Products must match description, quality, color, size, and standards
            exactly.
          </li>
        </ul>

        <h4>
          <span>3.</span> Product Delivery Requirements&nbsp;
        </h4>

        <p>Sellers must:&nbsp;</p>

        <ul className="indent-choice">
          <li>
            Deliver products within agreed timelines and ensure packaging and
            delivery meet standards.
          </li>
          <li>
            Notify XSURFACE in advance of delivery dates and provide signed
            delivery notes and proof (photo/video).
          </li>
          <li>
            Resolve delivery errors immediately and bear related costs if due to
            seller error.
          </li>
        </ul>

        <h4>
          <span>4.</span> Product & Information Requirements&nbsp;
        </h4>

        <p>Sellers must:&nbsp;</p>

        <ul className="indent-choice">
          <li>
            Provide accurate, complete product details and maintain current
            stock status.
          </li>
          <li>
            Ensure all product descriptions, specifications, and visuals are up
            to date.
          </li>
          <li>
            Be solely responsible for any misleading or incorrect product
            information.
          </li>
          <li>Acknowledge XSURFACE's right to edit or remove content.</li>
        </ul>

        <h4>
          <span>5.</span> Marketing & Sample Products&nbsp;
        </h4>

        <ul className="indent-choice">
          <li>XSURFACE controls all marketing and sales campaigns.</li>
          <li>
            Sellers can collaborate on marketing via XSURFACE's promotion
            services.
          </li>
          <li>
            Sellers must provide sample products to XSURFACE (min. 5
            pcs/product).
          </li>
        </ul>

        <h4>
          <span>6.</span> Order Fulfillment Process&nbsp;
        </h4>

        <ul className="indent-choice">
          <li>
            Once an order is accepted, sellers must fulfill it per XSURFACE
            requirements.
          </li>
          <li>Tax invoices must match the VAT declared.</li>
          <li>
            Sellers bear responsibility for incorrect item details affecting
            delivery.
          </li>
          <li>
            Changes to confirmed orders require XSURFACE consent. Sellers are
            liable for resulting damages.
          </li>
        </ul>

        <h4>
          <span>7.</span> Handling Errors & Complaints&nbsp;
        </h4>

        <ul className="indent-choice">
          <li>XSURFACE will mediate customer complaints.</li>
          <li>
            Sellers must resolve product/service issues or reimburse XSURFACE.
          </li>
          <li>
            Return/refund and warranty obligations are the seller's
            responsibility.
          </li>
          <li>
            Buyers have the right to cancel within 7 days of receipt under Thai
            law.
          </li>
        </ul>

        <h4>
          <span>8.</span> Installation Services&nbsp;
        </h4>

        <p className="text-indent">If products include installation:&nbsp;</p>

        <ul className="indent-choice">
          <li>All work must meet advertised standards.</li>
          <li>Additional charges must be communicated upfront.</li>
          <li>
            Installation issues must be resolved within 3 days or seller may
            forfeit payment.
          </li>
          <li>
            Sellers are responsible for site protection, safety, and customer
            coordination.
          </li>
        </ul>

        <h4>
          <span>9.</span> Data Privacy Policy&nbsp;
        </h4>

        <ul className="indent-choice">
          <li>
            Sellers consent to XSURFACE's personal data protection policy.
          </li>
          <li>Sellers must comply with Thailand's PDPA regulations.</li>
          <li>
            Any data breach or unauthorized use must be reported to XSURFACE
            immediately.
          </li>
        </ul>

        <h4>
          <span>10.</span> Termination of Seller Relationship&nbsp;
        </h4>

        <p className="text-indent">
          Sellers may terminate the agreement with 30 days written notice. All
          pending orders must still be fulfilled.&nbsp;
        </p>

        <h4>
          <span>11.</span> Dispute Resolution&nbsp;
        </h4>

        <ul className="indent-choice">
          <li>Disputes will be governed by Thai law.</li>
          <li>Unresolvable disputes will be settled via arbitration.</li>
          <li>
            XSURFACE reserves the right to amend these terms without prior
            notice.
          </li>
        </ul>

        <p>&nbsp;</p>

        <p className="credit-remark">XSURFACE Co., Ltd. Date: June 27, 2025</p>
      </div>
    </Container>
  );
};

export default TermContentEn;
